import React from 'react';
import LegalDocument, { Dato, Enlace } from '../../components/legal/LegalLayout';
import { LEGAL } from '../../config/legalConfig';

const secciones = [
  {
    id: 'servicio',
    titulo: 'El servicio',
    contenido: (
      <p>
        {LEGAL.nombreSitio} es gratuito. Permite consultar el ranking, registrarte, proponer preguntas y participar en
        los concursos que se emiten en directo. Al crear una cuenta aceptas estas condiciones. Quién está detrás de la
        web se explica en el <Enlace to="/aviso-legal">aviso legal</Enlace>.
      </p>
    ),
  },
  {
    id: 'cuenta',
    titulo: 'Tu cuenta',
    contenido: (
      <ul>
        <li>Necesitas tener al menos {LEGAL.edadMinima} años.</li>
        <li>Una cuenta por persona, con datos reales.</li>
        <li>Eres responsable de tu contraseña. Si crees que alguien ha entrado en tu cuenta, cámbiala y avisa.</li>
        <li>El nombre de usuario no puede ser ofensivo ni hacerse pasar por otra persona o marca.</li>
        <li>Puedes borrar la cuenta cuando quieras desde tu perfil.</li>
      </ul>
    ),
  },
  {
    id: 'contenido',
    titulo: 'Qué puedes enviar',
    contenido: (
      <>
        <p>Las preguntas, explicaciones e imágenes que envíes deben cumplir estas normas:</p>
        <ul>
          <li>Que sean tuyas o tengas derecho a usarlas.</li>
          <li>Nada ilegal, ofensivo, discriminatorio, violento, sexual ni que acose a alguien.</li>
          <li>Sin datos personales de otras personas: nombres reales de particulares, direcciones, teléfonos, fotos.</li>
          <li>Sin spam, publicidad ni enlaces maliciosos.</li>
        </ul>
        <p>
          Todo se revisa antes de publicarse y puede pasar por una comprobación automática. Moderación puede corregir
          erratas, rechazar o retirar preguntas.
        </p>
      </>
    ),
  },
  {
    id: 'licencia',
    titulo: 'Tus preguntas',
    contenido: (
      <p>
        Las preguntas siguen siendo tuyas. Al enviarlas das permiso, gratis y sin fecha de caducidad, para usarlas,
        adaptarlas, mostrarlas en la web y emitirlas en directos y vídeos de los concursos. Si borras tu cuenta, el
        permiso se mantiene, pero dejan de mostrar tu nombre.
      </p>
    ),
  },
  {
    id: 'concursos',
    titulo: 'Concursos y ranking',
    contenido: (
      <ul>
        <li>
          Si concursas, tu nombre o apodo, tu foto y tu puntuación aparecerán en el directo, en la invitación y en el
          ranking. Puedes pedir que te retiren del ranking cuando quieras.
        </li>
        <li>Premios, insignias y rachas son virtuales y no tienen valor económico.</li>
        <li>El presentador decide sobre el desarrollo del concurso y la validez de las respuestas.</li>
      </ul>
    ),
  },
  {
    id: 'moderacion',
    titulo: 'Moderación',
    contenido: (
      <p>
        Si no se cumplen estas condiciones, se puede rechazar contenido, suspender o eliminar la cuenta, según la
        gravedad. Siempre que sea posible se explicará el motivo. Si no estás de acuerdo con una decisión, pide que se
        revise escribiendo a <Dato campo="email" />.
      </p>
    ),
  },
  {
    id: 'denunciar',
    titulo: 'Denunciar contenido',
    contenido: (
      <>
        <p>
          Si ves algo ilegal o que incumple las normas, escribe a <Dato campo="email" /> indicando:
        </p>
        <ul>
          <li>Qué contenido es y dónde aparece.</li>
          <li>Por qué crees que debe retirarse.</li>
          <li>Tu nombre y email, para poder responderte.</li>
        </ul>
        <p>Se revisará lo antes posible y recibirás respuesta con la decisión.</p>
      </>
    ),
  },
  {
    id: 'responsabilidad',
    titulo: 'Disponibilidad',
    contenido: (
      <p>
        La web se ofrece tal cual, de forma gratuita. Puede haber cortes por mantenimiento o problemas técnicos. No se
        responde del mal uso que hagan otros usuarios ni de lo que publiquen, más allá de retirar lo que sea ilícito.
      </p>
    ),
  },
  {
    id: 'cambios',
    titulo: 'Cambios y ley aplicable',
    contenido: (
      <p>
        Estas condiciones pueden cambiar para adaptarse a la ley o al servicio; los cambios importantes se avisarán en
        la web. Se aplica la legislación española y, si eres consumidor, son competentes los juzgados de tu domicilio.
        Cómo se tratan tus datos está en la <Enlace to="/privacidad">política de privacidad</Enlace>.
      </p>
    ),
  },
];

const CondicionesUsoPage = () => (
  <LegalDocument
    titulo="Condiciones de uso"
    intro="Las reglas del juego para usar Diegoncurso y enviar preguntas."
    secciones={secciones}
  />
);

export default CondicionesUsoPage;
